import React from 'react';
import { motion } from 'framer-motion'; // Using Framer Motion for adaptive UI
import { useKernel } from '../hooks/AIKernel'; // Import the Symbolic Engine
import './MidInfoBar.css';

const MidInfoBar = ({ clearLinkList, linkCount = 0 }) => {
  // --- AI Kernel Integration ---
  const { agentState, reportBehavior } = useKernel();

  const handleClear = () => {
    // 1. Execute the original prop function
    clearLinkList();

    // 2. 🧠 AI Sensor: Report the behavioral event
    // Clearing history strongly indicates a desire for privacy or a "fresh start"
    reportBehavior('privacy_focused', 3, 'interest');
    reportBehavior('data_reset', 1, 'behavior');
  };

  return (
    // Apply the dynamic AI theme to the wrapper
    <div className={`mid-info-bar ${agentState.theme}`}>
      <div className="info-text section-headings">
        <span>Recent links</span>
        <span className="link-count">{linkCount}</span>
      </div>
      
      {/* Adaptive UI Button */}
      <motion.button 
        className="clear-button normal-text"
        onClick={handleClear}
        disabled={linkCount === 0}
        // AI Actuator: If the user is rage-clicking elsewhere, strip the bouncy 
        // animations here to reduce cognitive load and visual noise.
        whileHover={!agentState.ui.simplifyAnimations ? { scale: 1.05 } : {}}
        whileTap={!agentState.ui.simplifyAnimations ? { scale: 0.95 } : {}}
      >
        Clear history
      </motion.button>
    </div>
  );
};

export default MidInfoBar;